import { Controller } from 'react-hook-form';
import { type CheckboxControllerProps } from './types';
import { Checkbox } from '.';

export const CheckboxController = ({
  control,
  name,
  id,
  label,
  required,
  rules,
  className,
}: CheckboxControllerProps): React.ReactElement => (
  <Controller
    name={name}
    control={control}
    rules={rules}
    render={({ field }) => (
      <Checkbox
        id={id ?? name}
        label={label}
        required={required}
        className={className}
        onCheckedChange={field.onChange}
        checked={field.value ?? false}
      />
    )}
  />
);
